const animateCss = (element, animation, prefix = 'animate__', isRemoveOnEnd=false) => {
    return new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        let node;
        if (typeof element === "string") {
            node = document.querySelector(element);
        } else {
            node = element
        }
        if (!node) return;
        node.classList.add(`${prefix}animated`, animationName);
      
        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
          event.stopPropagation();
          if (isRemoveOnEnd) {
            node.classList.remove(`${prefix}animated`, animationName);
          }
          resolve(node);
        }
      
        node.addEventListener('animationend', handleAnimationEnd, {once: true});
    });
}

export default animateCss;